import { UpdateUserPayload } from "../../../api/types/user"
import { FormErrors } from "../../FieldError"

export const validateUser = (data: UpdateUserPayload): [boolean, FormErrors<UpdateUserPayload>] => {
  let isValid: boolean = true;
  let errors: FormErrors<UpdateUserPayload> = {}

  if (!data.firstname) {
    errors.firstname = "Jméno je povinné pole."
    isValid = false
  }

  if (!data.lastname) {
    errors.lastname = "Příjmení je povinné pole."
    isValid = false
  }

  if (!data.email) {
    errors.email = "E-mail je povinné pole."
    isValid = false
  }

  if (!data.phone && !data.mobile) {
    errors.phone = "Telefon je povinné pole."
    isValid = false
  }

  if (!data.mobile && !data.phone) {
    errors.mobile = "Mobil je povinné pole."
    isValid = false
  }

  if (!data.billingAddress) {
    errors.billingAddress = "Fakturační adresa je povinné pole."
    isValid = false
  }

  return [isValid, errors]
}
